import React, { ChangeEvent, FormEvent } from 'react';
import cn from 'classnames';
import Link from 'next/link';

import { trackEvent } from '@/helpers/heap/trackEvent';

import { InputText } from '@/components/atoms/Inputs/InputText';
import { Button } from '@/components/atoms/Button';
import { IconArrowRight } from '@/components/icons';
import { Loading } from '@/components/Loading';

type DialogFormSectionProps = {
	gettingData: boolean;
	userInput: string;
	onChangeHandler: (e: ChangeEvent<HTMLInputElement>) => void;
	onSubmit: (e: FormEvent<HTMLFormElement>) => void;
	closeBox: () => void; // Remove MouseEvent parameter
	conversationLength?: number; // Track how many questions were asked before the click
};

const ctaLabel = 'Get a new system';

const DialogFormSection = (props: DialogFormSectionProps) => {
	const {
		gettingData,
		userInput,
		onChangeHandler,
		onSubmit,
		closeBox,
		conversationLength,
	} = props;

	const handleReplaceFlowClick = () => {
		// This will help us track if people are using this shortcut
		trackEvent('AI Box CTA Clicked', {
			'CTA Label': ctaLabel,
			'CTA Location': 'AI Search Dialog',
			'Questions Asked Count': conversationLength?.toString() || '0',
		});
		closeBox();
	};

	return (
		<div
			data-testid="DialogFormSection"
			className="mx-auto h-max w-full overflow-x-hidden px-6 pb-7"
		>
			<div
				className={cn(
					'relative flex h-5 items-center justify-center py-4 transition-all duration-300 ease-in-out',
					gettingData ? 'scale-125' : 'scale-0',
				)}
			>
				<Loading />
			</div>
			<form
				onSubmit={onSubmit}
				className="flex flex-row items-center justify-center gap-4"
			>
				<InputText
					id={'search-hvac'}
					label={'Do you need help?'}
					name={'search-hvac'}
					value={userInput}
					onChange={onChangeHandler}
					fieldsetClassName="flex-1"
				/>
				<Button
					variant={'medium-primary-gradient'}
					className="w-30 disabled:opacity-50"
					disabled={gettingData}
				>
					Ask AI
				</Button>
			</form>
			<Link
				data-testid={'ReplaceFlowLink'}
				href={'/replace/get-started/'}
				onClick={handleReplaceFlowClick}
				className="group mt-6 flex items-center justify-center gap-1 text-sm tracking-tight text-sky-600 hover:text-sky-700"
			>
				<span>{ctaLabel}</span>
				<IconArrowRight
					className="h-3 w-3 fill-sky-600 group-hover:fill-sky-700"
					aria-hidden="true"
				/>
			</Link>
		</div>
	);
};

export default DialogFormSection;
